
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"23.521"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bababa"}},[_c('path',{attrs:{"d":"M8.157 12.477a.559.559 0 00-.559-.559H5.647a.559.559 0 00-.559.559v1.951a.559.559 0 00.559.559h1.951a.559.559 0 00.559-.559zm0 0M13.035 12.477a.559.559 0 00-.559-.559h-1.952a.559.559 0 00-.559.559v1.951a.559.559 0 00.559.559h1.952a.559.559 0 00.559-.559zm0 0M17.912 12.477a.559.559 0 00-.559-.559h-1.947a.559.559 0 00-.559.559v1.951a.559.559 0 00.559.559h1.951a.559.559 0 00.559-.559zm0 0M8.157 17.354a.559.559 0 00-.559-.559H5.647a.559.559 0 00-.559.559v1.951a.558.558 0 00.559.559h1.951a.558.558 0 00.559-.559zm0 0M13.035 17.354a.559.559 0 00-.559-.559h-1.952a.559.559 0 00-.559.559v1.951a.559.559 0 00.559.559h1.952a.558.558 0 00.559-.559zm0 0M17.912 17.354a.559.559 0 00-.559-.559h-1.947a.559.559 0 00-.559.559v1.951a.559.559 0 00.559.559h1.952a.559.559 0 00.559-.559zm0 0"}})]),_c('path',{attrs:{"d":"M20.953 2.743v2.828a2.318 2.318 0 01-2.329 2.309h-1.469a2.33 2.33 0 01-2.343-2.309V2.732H8.19v2.839A2.33 2.33 0 015.847 7.88H4.378a2.317 2.317 0 01-2.329-2.309V2.743A2.111 2.111 0 000 4.837v16.575a2.113 2.113 0 002.108 2.109h18.783A2.116 2.116 0 0023 21.412V4.837a2.111 2.111 0 00-2.047-2.094zm-.683 17.638a.909.909 0 01-.911.906H3.6a.91.91 0 01-.912-.906v-8.562a.909.909 0 01.912-.907h15.758a.909.909 0 01.911.907zm0 0","fill":"#bababa"}}),_c('path',{attrs:{"d":"M4.383 6.558h1.523a.836.836 0 00.837-.836V.836A.836.836 0 005.906 0H4.383a.836.836 0 00-.837.836v4.888a.836.836 0 00.837.836zm0 0M17.056 6.558h1.522a.836.836 0 00.837-.836V.836A.836.836 0 0018.578 0h-1.522a.837.837 0 00-.837.836v4.888a.836.836 0 00.837.836zm0 0","fill":"#bababa"}})])
          )
        }
      }
    